import { render } from "./EvaluationScreen.vue?vue&type=template&id=7fc4915f"
import script from "./EvaluationScreen.vue?vue&type=script&lang=js"
export * from "./EvaluationScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__